<script setup lang="ts">
import { whenever } from '@vueuse/core'

const modals = useModalManager()
const userStore = useUserStore()
const terminPharmacy = useTerminPharmacy()

whenever(() => userStore.showUnverifiedModal, () => {
  userStore.setShowUnverifiedModal(false)
  modals.show('UnverifiedUser')
})
</script>

<template>
  <!-- Login -->
  <LazyModalLogin
    v-if="modals.isMounted('Login')"
  />

  <!-- AGB -->
  <LazyModalAGB
    v-if="modals.isMounted('Agb')"
  />

  <!-- Logged out -->
  <LazyModalLoggedOut
    v-if="modals.isMounted('LoggedOut')"
  />

  <!-- Logout confirm -->
  <LazyModalLogout
    v-if="modals.isMounted('LogoutConfirm')"
  />

  <!-- Product max amount -->
  <LazyIaModalMaxAmount
    v-if="modals.isMounted('MaxAmount')"
  />

  <!-- Pharmacy switch -->
  <LazyModalPharmacySwitch
    v-if="modals.isMounted('PharmacySwitch')"
  />

  <!-- Apofinder search bar -->
  <LazyModalApofinderSearch
    v-if="modals.isMounted('ApofinderSearch')"
  />

  <!-- Apofinder Landing Page search bar -->
  <LazyModalApofinderLPSearch
    v-if="modals.isMounted('ApofinderLPSearch')"
  />

  <LazyModalApofinderScan
    v-if="modals.isMounted('ApofinderScan')"
  />

  <LazyModalApofinderModalApofinderCardLink
    v-if="modals.isMounted('ApofinderCardLink')"
  />

  <LazyModalCameraAccessDenied
    v-if="modals.isMounted('CameraAccessDenied')"
  />

  <LazyModalAdvertisement
    v-if="modals.isMounted('Advertisement')"
  />

  <!-- Apofinder search filters -->
  <LazyModalModalFiltersModalApofinderFilters
    v-if="modals.isMounted('ApofinderFilters')"
  />

  <!-- Unverified user -->
  <LazyIaModalUnverified
    v-if="modals.isMounted('UnverifiedUser')"
  />

  <!-- Coupon confirm -->
  <LazyModalCouponConfirm
    v-if="modals.isMounted('CouponConfirm')"
  />

  <!-- Empty cart -->
  <LazyModalCheckoutModalEmptyCart
    v-if="modals.isMounted('EmptyCart')"
  />

  <!-- Cart Emptied -->
  <LazyModalCheckoutModalCartEmptied
    v-if="modals.isMounted('CartEmptied')"
  />

  <!-- Pharmacy partners modal -->
  <LazyApoFinderModalApofinderPharmacyPartners
    v-if="modals.isMounted('ApofinderPharmacyPartners')"
  />

  <!-- Pharmacy appointment booking modal -->
  <LazyApoFinderModalApofinderTermin
    v-if="modals.isMounted('ApofinderTermin')"
    :pharmacy="terminPharmacy"
    @close="terminPharmacy = undefined"
  />

  <!-- Epaper modal -->
  <LazyModalEpaperUnsubscribe
    v-if="modals.isMounted('EpaperUnsubscribe')"
  />

  <!-- IaAppDownload modal -->
  <LazyModalIaAppDownload
    v-if="modals.isMounted('IaAppDownload')"
  />

  <!-- LocationPermission modal -->
  <LazyModalLocationDisabled
    v-if="modals.isMounted('LocationDisabled')"
  />

  <!-- WhatsApp modal -->
  <LazyModalWhatsAppModal
    v-if="modals.isMounted('WhatsApp')"
  />
</template>
